import { createTheme, ThemeProvider } from '@mui/material';
import React, { useMemo } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DeliveryApp from './componentes/DeliveryApp';
import EntryPage from './paginas/EntryPage';
import { useDeliveryStore } from './store/deliveryStore';

const TEMA_PADRAO = { corPrimaria: '#e53935', corSecundaria: '#ffffff' };

function AppComTema() {
  const unidade = useDeliveryStore((s) => s.unidade);

  const theme = useMemo(() => {
    const primaria = unidade?.corPrimaria || TEMA_PADRAO.corPrimaria;
    const secundaria = unidade?.corSecundaria || TEMA_PADRAO.corSecundaria;
    return createTheme({
      palette: {
        primary: { main: primaria },
        secondary: { main: secundaria },
      },
      typography: {
        fontFamily: 'Inter, sans-serif',
      },
    });
  }, [unidade?.corPrimaria, unidade?.corSecundaria]);

  return (
    <ThemeProvider theme={theme}>
      <ToastContainer position="top-center" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<EntryPage />} />
          <Route path="/:tenant" element={<DeliveryApp />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default function App() {
  return <AppComTema />;
}
